import { ArrowRight, CheckCircle2 } from 'lucide-react';

import { ButtonLink } from '../components/Button';
import { Container } from '../components/Container';
import type { LandingContent } from '../content/types';
import { sectionIds } from '../lib/routes';

type HeroSectionProps = {
  content: LandingContent;
};

export function HeroSection({ content }: HeroSectionProps) {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <Container className="hero__grid">
        <div className="hero__copy">
          <p className="eyebrow">{content.hero.eyebrow}</p>
          <h1 id="hero-title">{content.hero.h1}</h1>
          <p className="hero__lead">{content.hero.lead}</p>
          <div className="hero__actions">
            <ButtonLink href={`#${sectionIds.contact}`}>
              {content.hero.primaryCta}
              <ArrowRight aria-hidden="true" size={18} />
            </ButtonLink>
            <ButtonLink variant="secondary" href={`#${sectionIds.services}`}>
              {content.hero.secondaryCta}
            </ButtonLink>
          </div>
          <ul className="hero__trust" aria-label="Trust signals">
            {content.hero.trustBullets.map((item) => (
              <li key={item}>
                <CheckCircle2 aria-hidden="true" size={18} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="hero__visual" aria-label={content.hero.visualAlt}>
          <img
            src="/assets/architecture-map.svg"
            width="720"
            height="540"
            alt={content.hero.visualAlt}
            decoding="async"
          />
        </div>
      </Container>
    </section>
  );
}
